import SubscriptionsCard from '../../containers/Subscriptions/Card';
import { accessTypeEnum } from '../../lib/enum';

export default [
    {
        component: SubscriptionsCard,
        path: '/admin/subscriptions/',
        access: [accessTypeEnum.admin, accessTypeEnum.adminBranch],
    },
];